import styled from 'styled-components'
import React from 'react'
import { IconCrossCircle } from '../../iconography/Icons/Icons'

const RemoveIconStyled = styled(IconCrossCircle)`
  transition: 0.2s opacity ease;
  margin-left: 5px;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`
const TagStyled = styled.div`
  display: grid;
  grid-template-columns: auto max-content;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  background: rgba(3, 123, 255, 0.08);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 4px 8px;
  margin: 0 8px 8px 0;
`

export const Tag: React.FC<{
  title: React.ReactNode
  index: string
  onRemove?: (index: string) => void
  className?: string
}> = ({ title, index, onRemove, className }) => {
  return (
    <TagStyled className={className}>
      {title}
      <RemoveIconStyled
        onClick={e => {
          e.stopPropagation()
          onRemove?.(index)
        }}
        role="button"
      />
    </TagStyled>
  )
}
